import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({

    st0: {
        fill: '#FFFFFF',
    },

}));
